export const COLLTRAIN_VERSION = '3.6';

export const COLLTRAIN_LOGO = '/img/branding/colltrain-logo.svg';
export const COLLTRAIN_LOGO_MEDIUM = COLLTRAIN_LOGO;// '/img/branding/colltrain-logo--hr-67.png';
export const COLLTRAIN_LOGO_LARGE = COLLTRAIN_LOGO;// '/img/branding/colltrain-logo-hr.png';

export const GLOBAL_STATE_VERSION = 10;